
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"70","height":"70","viewBox":"0 0 91.985 84.776"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 519","fill":"none","stroke":"#707070","stroke-miterlimit":"10","stroke-width":"3.5"}},[_c('g',{attrs:{"data-name":"Group 517","transform":"translate(18.812 36.367)"}},[_c('path',{attrs:{"data-name":"Path 702","d":"M4.647 36.606l8.889-11.294a3.167 3.167 0 014.985 0l8.889 11.294"}}),_c('path',{attrs:{"data-name":"Path 703","d":"M21.091 28.01l10.132-12.877a3.17 3.17 0 014.985 0l16.96 21.4"}}),_c('ellipse',{attrs:{"data-name":"Ellipse 46","cx":"4.099","cy":"4.098","rx":"4.099","ry":"4.098","transform":"translate(7.819 6.313)","stroke-linecap":"round"}}),_c('path',{attrs:{"data-name":"Path 704","d":"M28.218 18.946c1.561.917 3.2 1.924 3.2 1.924l2.3-1.555 1.961 1.431 3.205-2.219","stroke-linecap":"round"}}),_c('rect',{attrs:{"data-name":"Rectangle 300","width":"55.069","height":"36.604","rx":"2.349","stroke-linecap":"round"}})]),_c('g',{attrs:{"data-name":"Group 518","stroke-linecap":"round","transform":"translate(1.75 1.75)"}},[_c('rect',{attrs:{"data-name":"Rectangle 301","width":"88.484","height":"57.972","rx":"5.881","transform":"translate(0 23.304)"}}),_c('path',{attrs:{"data-name":"Path 705","d":"M88.485 31.341V15.256a6.1 6.1 0 00-6.1-6.1H47.507a6.1 6.1 0 01-5.08-2.715l-2.472-3.723a6.1 6.1 0 00-5.08-2.715H6.102a6.1 6.1 0 00-6.1 6.1v25.238"}})])])])
          )
        }
      }
    